export const RECORDED_SESSION = 1;
export const YOUTUBE_VIDEO_SESSION = 2;
export const ZOOM_SESSION = 3;